var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ibx-item-error"},[_c('div',{staticClass:"ibx-item-error__content"},[_c('font-awesome-icon',{staticClass:"icon mr-2",attrs:{"icon":['fas', 'exclamation-triangle']}}),_c('span',[_vm._v(_vm._s(_vm.message))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }